import { BaseMutations } from '@/store/base-mutations';
import { Clients } from '@/modules/clients/types';
import { PaginationProps, TableOptions } from '@/types';
import ProjectsState from './state';
import { Projects, ProjectsFilters } from '../types';
import { default_new_project } from '../services';

export function update_product_price(products: Projects.AddProduct[], prod: Projects.AddProduct, price_type: 'client_price' | 'desired_price') {
  const updated_products = products.map((product: Projects.AddProduct) => {
    if (product.id === prod.id) {
      return { ...product, [price_type]: prod[price_type] };
    }
    return product;
  });

  return updated_products;
}

export default class ProjectsMutations extends BaseMutations<ProjectsState> {
  SET_PROJECTS(project: Projects.Project[]) {
    this.state.projects = project;
  }

  SET_CURRENT_PROJECT(project: Projects.Project) {
    this.state.current_project = project;
  }

  SET_PARNER_CONTACT_PERSONS(items: string[]) {
    this.state.partner_contact_persons = items;
  }

  SET_ORGANIZATIONS(organizations: string[]) {
    this.state.organizations = organizations;
  }

  TOGGLE_LOADING_PROJECTS(toggle: boolean) {
    this.state.projects_loading = toggle;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof ProjectsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_NEW_PROJECT({ key, value }: { key: keyof Projects.NewProject, value: unknown }) {
    this.state.new_project[key] = value;
  }

  ADD_PRODUCT(new_products: Projects.AddProduct[]) {
    this.state.products = [
      ...new_products, ...this.state.products,
    ];
  }

  ADD_EQUIPMENTS(new_equipments: Projects.Equipments[]) {
    this.state.equipments = [
      ...new_equipments, ...this.state.equipments,
    ];
  }

  ADD_COMPETITORS(new_competitors: Projects.Competitors[]) {
    this.state.competitors = [
      ...new_competitors, ...this.state.competitors,
    ];
  }

  UPDATE_ADD_PRODUCT_QUANTITY(payload: Projects.AddProduct) {
    const { product_code, quantity } = payload;
    const product_idx = this.state.products.findIndex((product) => product.product_code === product_code);

    if (product_idx !== -1) {
      const updated_quantity = Number(quantity);
      const update_products = [...this.state.products];

      update_products[product_idx].quantity = updated_quantity;
      this.state.products = update_products;
    }
  }

  REMOVE_PRODUCT(item_to_remove: Projects.AddProduct) {
    this.state.products = this.state.products.filter((product) => product.id !== item_to_remove.id);
  }

  REMOVE_EQUIPMENT(item_to_remove: Projects.Equipments) {
    this.state.equipments = this.state.equipments.filter((equp) => equp !== item_to_remove);
  }

  REMOVE_COMPETITOR(item_to_remove: Projects.Competitors) {
    this.state.competitors = this.state.competitors.filter((comp) => comp !== item_to_remove);
  }

  SET_CLIENT_PRICE(prod: Projects.AddProduct) {
    this.state.products = update_product_price(this.state.products, prod, 'client_price');
  }

  SET_PARTNER_PRICE(prod: Projects.AddProduct) {
    this.state.products = update_product_price(this.state.products, prod, 'desired_price');
  }

  UPD_PROD_QUANTITY({ item, quantity }: { item: Projects.AddProduct, quantity: string }) {
    const update_quantity = Number(quantity);

    const updated_products = this.state.products.map((product) => {
      if (product.id === item.id) {
        return { ...product, quantity: update_quantity };
      }
      return product;
    });

    this.state.products = updated_products;
  }

  RESET_NEW_PROJECT() {
    this.state.new_project = default_new_project();
    this.state.products = [];
    this.state.equipments = [];
    this.state.competitors = [];
  }

  SET_CLIENTS_IDS(ids: number[]) {
    this.state.new_project.client_ids = ids;
  }

  CLEAR_CLIENTS_IDS() {
    this.state.new_project.client_ids = [];
  }

  SET_CLIENTS_FOR_PROJECT(clients: Clients.ClientToAddItem[]) {
    this.state.clients_for_project = clients;
  }

  CLEAR_CLIENTS_FOR_PROJECT() {
    this.state.clients_for_project = [];
  }

  SET_CATALOG_PRODUCTS_TABLE_OPTIONS(opts: TableOptions) {
    this.state.catalog_products_table_options = opts;
  }

  UPD_CATALOG_PRODUCTS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.catalog_products_table_options[key] = value;
  }

  UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.catalog_products_pagination_props[key] = value;
  }

  SET_CATALOG_PRODUCTS(catalog_products: Projects.CatalogProduct[]) {
    this.state.catalog_products = catalog_products;
  }

  SET_CATALOG_PRODUCTS_LOADING(value: boolean) {
    this.state.catalog_products_loading = value;
  }

  UPD_CATALOG_PRODUCT_FILTER_KEY({ key, value }: { key: keyof Projects.CatalogProductRequestFilters, value: unknown }) {
    this.state.catalog_products_filters[key] = value;
  }
}
